// Prod_US: keep both videos until the second test is done, then upload them one after the other
// with the app's own upload (startMeasurementVideoUpload: asset token -> signed-URL PUT -> event).
import { startMeasurementVideoUpload } from "../userDetail/testModule/measurementBackgroundUpload";
import { PROD_US_MODULE_IDS } from "./prodUsConfig";
import {
  heldProdUsModuleIds,
  heldProdUsVideo,
  releaseProdUsVideo,
} from "./prodUsVideoHold";

export {
  clearProdUsVideos,
  hasAllProdUsVideos,
  heldProdUsModuleIds,
  holdProdUsVideo,
} from "./prodUsVideoHold";

/*
 * Uploads what is still held, in test order. A video leaves the hold once its upload and its
 * event call succeed, so "Try again" sends only what is left.
 *   onProgress(index)  index of the video now uploading: 0 = first of the two, 1 = second
 *   isCancelled()      true after Cancel Upload: stops before the next video
 * Resolves { status: "done" | "failed" | "cancelled" | "missing", index }
 */
export const uploadProdUsVideos = async ({
  onProgress = () => {},
  isCancelled = () => false,
} = {}) => {
  if (heldProdUsModuleIds().length === 0)
    return { status: "missing", index: 0 };
  for (let index = 0; index < PROD_US_MODULE_IDS.length; index += 1) {
    const moduleId = PROD_US_MODULE_IDS[index];
    const video = heldProdUsVideo(moduleId);
    if (!video) continue; // already uploaded on an earlier try
    if (isCancelled()) return { status: "cancelled", index };
    onProgress(index);
    const response = await startMeasurementVideoUpload({
      file: video.file,
      moduleInfo: video.moduleInfo,
      userId: video.personId,
      notify: false,
    });
    if (response === null) return { status: "failed", index };
    releaseProdUsVideo(moduleId);
  }
  return { status: "done", index: PROD_US_MODULE_IDS.length - 1 };
};
